import React from "react";
import { canHideCrmDataFieldOnWaitlist } from "../../../utils/crmDataFields";

export const CRM_DATA_FIELD_EDITOR_ROWS = [
  { fieldKey: "company", label: "Company" },
  { fieldKey: "title", label: "Title" },
  { fieldKey: "firstName", label: "First Name" },
  { fieldKey: "lastName", label: "Last Name" },
  { fieldKey: "email", label: "Email Address" },
  { fieldKey: "phone", label: "Phone Number" },
  { fieldKey: "address1", label: "Address 1" },
  { fieldKey: "address2", label: "Address 2" },
  { fieldKey: "city", label: "City" },
  { fieldKey: "state", label: "State" },
  { fieldKey: "postal", label: "Postal Code" },
  { fieldKey: "experience", label: "Porsche Experience" },
  { fieldKey: "purchaseTimeFrame", label: "Purchase Timeframe" },
  { fieldKey: "modelInterest", label: "Model Interest" },
  { fieldKey: "dealer", label: "Dealer" },
];

export const EventCrmDataField = ({
  fieldKey,
  label,
  eventData,
  setEventData,
  formGroupCls,
}) => {
  const field = eventData?.dataFields?.[fieldKey] || {};
  const allowHideOnWaitlist = canHideCrmDataFieldOnWaitlist(fieldKey);

  const updateField = (patch) => {
    setEventData({
      ...eventData,
      dataFields: {
        ...eventData?.dataFields,
        [fieldKey]: {
          ...eventData?.dataFields?.[fieldKey],
          ...patch,
        },
      },
    });
  };

  return (
    <div className="flex flex-wrap gap-4">
      <div className="flex-1 min-w-0">{label} </div>
      <div className="flex-none">
        <div className={field.visible ? formGroupCls : "hidden"}>
          <label className="checkbox-container">
            Required
            <input
              type="checkbox"
              onChange={(e) => updateField({ required: e.target.checked })}
              id={`${fieldKey}.required`}
              name={`${fieldKey}.required`}
              checked={field.required || false}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      </div>
      {!field.visible && (
        <div className="flex-none">
          <div className={formGroupCls}>
            <label className="checkbox-container">
              Admin Visible
              <input
                type="checkbox"
                onChange={(e) => updateField({ adminOnly: e.target.checked })}
                id={`${fieldKey}.adminOnly`}
                name={`${fieldKey}.adminOnly`}
                checked={field.adminOnly || false}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      )}
      <div className="flex-none">
        <div className={formGroupCls}>
          <label className="checkbox-container">
            Visible
            <input
              type="checkbox"
              onChange={(e) => updateField({ visible: e.target.checked })}
              id={`${fieldKey}.visible`}
              name={`${fieldKey}.visible`}
              checked={field.visible || false}
            />
            <span className="checkmark"></span>
          </label>
        </div>
      </div>
      {allowHideOnWaitlist && field.visible && (
        <div className="flex-none">
          <div className={formGroupCls}>
            <label className="checkbox-container">
              Hide on waitlist
              <input
                type="checkbox"
                onChange={(e) =>
                  updateField({ hideOnWaitlist: e.target.checked })
                }
                id={`${fieldKey}.hideOnWaitlist`}
                name={`${fieldKey}.hideOnWaitlist`}
                checked={field.hideOnWaitlist || false}
              />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      )}
    </div>
  );
};
